import { Controller } from "@hotwired/stimulus"

// Image sizing controller for custom width toggle
export default class extends Controller {
    static targets = ["customWidth", "numberInput"]
    static values = { blockId: String }

    toggleCustom(event) {
        const isCustom = event.target.value === 'custom'

        if (this.hasCustomWidthTarget) {
            if (isCustom) {
                this.customWidthTarget.classList.remove('hidden')
                // Apply current custom value immediately
                const currentWidth = this.numberInputTarget.value || 400
                this.updatePreview(currentWidth)
            } else {
                this.customWidthTarget.classList.add('hidden')
                // Clear inline style to let classes take over
                this.updatePreview(null)
            }
        }
    }

    syncNumber(event) {
        const val = event.target.value
        // Sync slider to number input
        if (this.hasNumberInputTarget) {
            this.numberInputTarget.value = val
        }
        this.updatePreview(val)
    }

    syncRange(event) {
        const val = event.target.value
        // Sync number input to slider
        const slider = this.element.querySelector('input[type="range"]')
        if (slider) {
            slider.value = val
        }
        this.updatePreview(val)
    }

    updatePreview(width) {
        if (!this.blockIdValue) return

        // Find the image in the preview canvas
        const wrapper = document.querySelector(`[data-block-preview-id="${this.blockIdValue}"]`)
        if (!wrapper) return

        const img = wrapper.querySelector('img')
        if (!img) return

        if (width) {
            img.style.maxWidth = `${width}px`
            img.style.width = '100%'
        } else {
            img.style.maxWidth = ''
            img.style.width = ''
        }
    }
}
